import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes'
import {connect} from 'react-redux';
import AppBar from 'material-ui/AppBar';
import withWidth, {MEDIUM, LARGE} from 'material-ui/utils/withWidth';
import FlatButton from 'material-ui/FlatButton';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import NavMenu from './NavMenu';
import {doLogout, requestLogin} from '../../model/action-creators/login-actions';
import {Keys} from '../../model/constants'
import * as Immutable from "immutable";
import {loadWorkSessionItems} from "../../model/action-creators/item-actions";
import {Constants} from "../../model/constants";


class Master extends React.Component {

    constructor(props) {
        super(props);
        this.handleMenuToggle = this.handleMenuToggle.bind(this);
        this.state = {
            menuOpen: false,
        }
    }

    componentWillMount() {
        this.setState({muiTheme: getMuiTheme()});

    }
    componentWillReceiveProps(nextProps) {
        const nextWorkSessionId = nextProps.currentWorkSession.get(Keys.ID);

        if( nextWorkSessionId != this.currentWorkSessionId) {
            this.stopUpdating();
            if( nextWorkSessionId) {
                this.currentWorkSessionId = nextWorkSessionId;
                this.startUpdating(nextWorkSessionId);
            }
        }
    }
    componentWillUnmount() {
        this.stopUpdating();
    }

    startUpdating(sessionId) {
        if(process.env.REACT_APP_NO_AUTOUPDATE) {
            return;
        }
        console.log("Starting interval for "+sessionId)
        this.interval = setInterval(() => {
            this.props.doLoadItems(sessionId);
        }, Constants.ITEMS_UPDATE_INTERVAL)

    }
    stopUpdating() {
        if(process.env.REACT_APP_NO_AUTOUPDATE) {
            return;
        }
        if( this.interval) {
            console.log("Stopping interval")
            clearInterval(this.interval);
            this.interval = null;
        }
    }
    handleMenuToggle() {
        this.setState({menuOpen: !this.state.menuOpen});
    }

    getAppBar() {
        const {loginState, doLogout, doRequestLogin} = this.props;
        const styles = {
            appBar: {
                position: 'fixed',
                zIndex: this.state.muiTheme.zIndex.appBar + 2,
                top: 0,
            },
        };

        return (
            <AppBar onLeftIconButtonTouchTap={this.handleMenuToggle}
                    title='Production Manager'
                    zDepth={0}
                    iconElementRight={ <FlatButton label={loginState.get(Keys.LoginStateMeta.LOGGED_IN)?"Logout":"Login"}/> }
                    onRightIconButtonTouchTap={loginState.get(Keys.LoginStateMeta.LOGGED_IN)?doLogout:doRequestLogin}
                    style={styles.appBar}
                    showMenuIconButton={false}
            />
        );
    }

    getNormalPage() {
        const {
            children,
            width,
        } = this.props;

        const menuOpen = this.state.menuOpen;
        let menuMode;
        let leftMargin;

        if (width === LARGE || width === MEDIUM && menuOpen) {
            menuMode = 'BIG';
            leftMargin = 190;
        } else /*if (width === MEDIUM)*/ {
            menuMode = 'SMALL';
            leftMargin = 64;
        } /*else { // innerWidth < 768
            menuMode = 'DRAWER';
            leftMargin = 0;
        }*/
        return (
            <div>
                {this.getAppBar()}
                <div style={{marginTop: 64, display: 'inline-flex', flexFlow: 'row no-wrap', width: '100%', position:'relative'}}>
                    <NavMenu onMenuToggle={this.handleMenuToggle} mode={menuMode} open={menuOpen} docked={false}/>
                    <div style={{marginLeft: leftMargin, padding: 24, width: '100%', position:'relative'}}>
                        {children}
                    </div>
                </div>
            </div>

        )
    }

    render() {
        const {
            loginState,
        } = this.props;

        const loginRequested = /user|server(-failed)?/.test(loginState.get(Keys.LoginStateMeta.LOGIN_PROGRESS));
        return (
            this.getNormalPage()
        )

    }
}

Master.propTypes = {
    children: React.PropTypes.node.isRequired,
    width: React.PropTypes.number.isRequired,
    loginState: ImmutablePropTypes.map.isRequired,
    doLogout: React.PropTypes.func.isRequired,
    doRequestLogin: React.PropTypes.func.isRequired,
    currentWorkSession: ImmutablePropTypes.map.isRequired,
};
const mapStateToProps = (state) => {
    return {
        loginState: state.loginState,
        currentWorkSession:state.currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION, Immutable.Map())
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        doLogout: () => dispatch(doLogout()),
        doRequestLogin: () => dispatch(requestLogin()),
        doLoadItems: (workSessionId) => dispatch(loadWorkSessionItems( workSessionId)),

    }
};

export default withWidth()(connect(mapStateToProps, mapDispatchToProps)(Master))


// WEBPACK FOOTER //
// ./src/ui/components/Master.js